export default __webpack_public_path__ + "static/media/aunty3.a16709aa.png";